import { render, staticRenderFns } from "./BlockUser.vue?vue&type=template&id=a1d3cd6c"
import script from "./BlockUser.vue?vue&type=script&lang=js"
export * from "./BlockUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports